import { type ReactNode, useId } from 'react';

import { Card, CardHeader, CardTitle } from '@nesso/ui/primitives/card';
import { Label } from '@nesso/ui/primitives/label';
import { RadioGroupItem } from '@nesso/ui/primitives/radio-group';

import { TruncatedContentCard } from './truncated-content-card';

type Props = {
    title: string;
    description: ReactNode;
    value: string;
};

export function RadioCardItem({ value, title, description }: Props) {
    const id = useId();

    return (
        <Label
            htmlFor={id}
            className="cursor-pointer [&:has([disabled])]:cursor-not-allowed [&:has([disabled])]:pointer-events-none"
        >
            <RadioGroupItem value={value} id={id} className="peer hidden" />
            <Card className="w-full lg:w-[20.25rem] xl:w-[26.25rem] gap-4 px-6 hover:bg-accent/50 hover:text-accent-foreground peer-data-[state=checked]:border-primary peer-data-[state=checked]:bg-primary/10">
                <CardHeader className="px-0">
                    <CardTitle>{title}</CardTitle>
                </CardHeader>
                <TruncatedContentCard>{description}</TruncatedContentCard>
            </Card>
        </Label>
    );
}
